import React from "react";

import crown from "../../assets/img/crown.svg";
import userimg from "../../assets/img/user-img.png";


const TopContributors = ({ coins }) => {
  return (
        <div className="col d-flex">
            <div className="right-card contributors-card w-100 h-100 mb-0">
            <h4 className="fw-bold mb-4 d-flex gap-3 align-items-center">
                <img src={crown} alt="crown" /> Top Contributors
            </h4>

            <div className="contributor-item">
                <div className="d-flex align-items-center">
                <div className="rank-circle">1</div>

                <img src={userimg} alt="" className="contributor-img" />

                <div>
                    <div className="ft-14 hname fw-semibold">Lena Morris</div>

                    <small className="hscore ft-12 fw-semibold">
                    <span>3,480 coins</span><span>96 score</span>
                    </small>
                </div>
                </div>
            </div>

            <div className="contributor-item">
                <div className="d-flex align-items-center">
                <div className="rank-circle">2</div>
                <img src={userimg} alt="" className="contributor-img" />
                <div>
                    <div className="ft-14 hname fw-semibold">Arjun Rao</div>
                    <small className="hscore ft-12 fw-semibold">
                    <span>2,915 coins</span><span>91 score</span>
                    </small>
                </div>
                </div>
            </div>

            <div className="contributor-item">
                <div className="d-flex align-items-center">
                <div className="rank-circle">3</div>
                <img src={userimg} alt="" className="contributor-img" />
                <div>
                    <div className="ft-14 hname fw-semibold">Sara Kim</div>

                    <small className="hscore ft-12 fw-semibold">
                    <span>2,640 coins</span><span>88 score</span>
                    </small>
                </div>
                </div>
            </div>
            </div>
        </div>
    );
}

    export default TopContributors;
